import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FavouriteHeartComponent } from './favourite-heart.component';

/** Grid of artist cards linking to their pages, with an optional favourite heart on each. */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-artist-grid',
  imports: [RouterLink, FavouriteHeartComponent],
  template: `
    <div class="artist-grid">
      @for (a of artists(); track a.id) {
      <div class="artist-card">
        @if (favouriteIds(); as ids) {
        <app-favourite-heart class="heart-slot" [saved]="ids.has(a.id)" [name]="a.name" list="Favourite Artists"
          (toggled)="favouriteToggle.emit(a)" />
        }
        <a class="artist-link" [routerLink]="['/artist', a.id]">
          <img [src]="a.images[1]?.url || a.images[0]?.url" [alt]="a.name" loading="lazy" />
          <strong>{{a.name}}</strong>
        </a>
      </div>
      }
    </div>
  `,
  styles: [`
    .artist-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 16px; }
    .artist-card { position: relative; border-radius: 8px; background: #fff; box-shadow: 0 1px 4px rgba(0,0,0,.15); }
    .artist-card:hover { box-shadow: 0 6px 14px rgba(0,0,0,.2); }
    .artist-link { display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 12px; color: inherit;
      text-decoration: none; text-align: center; }
    .artist-link img { width: 120px; height: 120px; border-radius: 50%; object-fit: cover; }
    .heart-slot { position: absolute; top: 4px; right: 4px; z-index: 1; }
  `]
})
export class ArtistGridComponent {
  artists = input.required<any[]>();
  /** Saved artist ids; when given, each card shows a heart that toggles the favourite. */
  favouriteIds = input<ReadonlySet<string> | null>(null);
  favouriteToggle = output<any>();
}
